module.exports = __webpack_public_path__ + "img/route_sender_number_2.4bfe54fa.png";